import ar from './ar';
import ca from './ca';
import en from './en';
import es from './es';
import pl from './pl';
import pt from './pt';

export { ar, ca, en, es, pl, pt };
